import { useTranslation } from "react-i18next";

export const useTranslatedCampaigns = () => {
  const { t } = useTranslation();
  return {
    po1: t("CustomerSupport:PO1CampaignLabel"),
    generic_campaign: t("CustomerSupport:GenericCampaignLabel"),
    gift_processing: t("CustomerSupport:GiftProcessingLabel"),
    standard_campaign: t("CustomerSupport:StandardCampaignLabel"),
    limitless_campaign: t("CustomerSupport:LimitlessCampaignLabel"),
    "action-based": t("CustomerSupport:ActionBasedLabel"),
    single_action_campaign: t("CustomerSupport:SingleActionCampaignLabel"),
    ranking_campaign: t("CustomerSupport:RankingCampaignLabel"),
    streak_campaign: t("CustomerSupport:StreakCampaignLabel"),
    redemption_campaign: t("CustomerSupport:RedemptionCampaignLabel"),
  };
};
